export enum IBoosterTextSegmentType {
    HIGHLIGHTED,
    BUTTON
}
export enum IBoosterTextSegmentType {
    HIGHLIGHTED,
    BUTTON
}
